import screen1 from '../../../assets/img/Portfolio/BrainSpace/1.webp';
import screen2 from '../../../assets/img/Portfolio/BrainSpace/2.webp';
import screen3 from '../../../assets/img/Portfolio/BrainSpace/3.webp';
import emoji from '../../../assets/img/Portfolio/BrainSpace/emoji.webp';

import './BrainSpace.css';

const BrainSpace = () => {
    return (
        <>
            <img className='screen' alt='' src={screen1}></img>
            <img className='screen' alt='' src={screen2}></img>
            <img className='screen' alt='' src={screen3}></img>
            <img className='screen emoji' alt='' src={emoji}></img>
        </>
    )
}
export default BrainSpace